import { type FC } from 'react';
import styled from 'styled-components';

import { useUserLocale } from '@/i18n/hooks';

interface Props {
  value: number;
  unit?: string;
}

/** Renders a styled text for displaying a value.
 * @param {number} value - The value to display.
 * @param {string} [unit] - The value unit.
 */
export const EsgValueText: FC<Props> = ({ value, unit }) => {
  const locale = useUserLocale();

  return (
    <StyledSpan className="font-body-demibold">{`${value.toLocaleString(locale)} ${unit}`}</StyledSpan>
  );
};

const StyledSpan = styled.span`
  font-size: 32px;
  margin: 24px 0;
`;
